/**
 * It just accepts and evaluate plain arrays with primitive values
 * Exeptions are it does not work on
 *
 * Nested arrays
 *
 * Objects
 *
 * Booleans
 *
 * @param {Array} arr1
 * @param {Array} arr2
 * @returns
 *
 */
export const _isSomeDifferent = (arr1 = [], arr2 = []) => {
  const a = {}
  const b = {}

  let isSomeValueDifferent = false

  if (arr1.length !== arr2.length) {
    return (isSomeValueDifferent = true)
  }

  for (let i = 0; i < arr1.length; i++) {
    const el1 = arr1[i]
    const el2 = arr2[i]
    a[el1] = el1
    b[el2] = el2
  }

  for (const key in a) {
    if (a[key] !== b[key]) {
      isSomeValueDifferent = true
      break
    }
  }
  return isSomeValueDifferent
}

/**
 * @param {Object} obj
 * @returns {Array<any>}
 *
 * By default it sorts array with primitive values like -> 
 * - `collaboratorIds` from `[4,1]` to `[1,4]`
 * 
 * 
 * Example: 
 * - Input
 * 
 * `{
    collaboratorIds: [],
    type: 'HOURS_BY_DAY',
    name: '',
    scheduleDays: [
      { dayOfWeek: 1, startTime: '', endTime: '', enabled: true },
      { dayOfWeek: 4, startTime: '', endTime: '', enabled: true },
      { dayOfWeek: 5, startTime: '', endTime: '', enabled: true }
    ],
    minutesEarly: '',
    minutesLate: ''
  }`
  *
 *
 * - Output:
 * 
 * `
 * [
    'collaboratorIds_', 'type_HOURS_BY_DAY',
    'name_',            'dayOfWeek_1',
    'startTime_',       'endTime_',
    'enabled_true',     'dayOfWeek_4',
    'startTime_',       'endTime_',
    'enabled_true',     'dayOfWeek_5',
    'startTime_',       'endTime_',
    'enabled_true',     'minutesEarly_',
    'minutesLate_'
  ]`
  *
 *
 * 
 */
export function _keyVal(obj = {}) {
  const _keys = Object.keys(obj)
  const result = []
  for (let i = 0; i < _keys.length; i++) {
    const key = _keys[i]
    if (Array.isArray(obj[key]) && typeof obj[key][0] === 'object') {
      const _keys2 = obj[key]
      for (let j = 0; j < _keys2.length; j++) {
        const key2 = _keys2[j]
        result.push(_keyVal(key2))
      }
    } else {
      if (Array.isArray(obj[key])) {
        obj[key].sort()
        result.push(`${key}_${obj[key]}`)
      } else {
        result.push(`${key}_${obj[key]}`)
      }
    }
  }

  return result.flat()
}

export function serializeParams(obj = {}) {
  const entries = Object.entries(structuredClone(obj))
  const temp = []
  for (let i = 0; i < entries.length; i++) {
    const value = entries[i][1]
    const key = entries[i][0]
    if (value === undefined || value === null) {
      continue
    }

    if (Array.isArray(value)) {
      const as = value.map((e) => `${key}=${e}`)
      temp.push(as)
    } else {
      temp.push(`${key}=${value}`)
    }
  }

  return `?${temp.flat(1).join('&')}`
}

export const _fileNameFromContentDisposition = (response) => {
  if (response.headers['content-disposition'] === undefined) {
    throw new Error('header content-disposition not found')
  }
  const [_, fileName] = response.headers['content-disposition'].split('=')
  return fileName.replaceAll('"', '')
}

export const _downloadFileFromContentDisposition = (
  { response } = {
    response: undefined,
  }
) => {
  if (response === undefined) {
    throw new Error('Response must be included')
  }
  const fileName = _fileNameFromContentDisposition(response)
  const url = window.URL.createObjectURL(response.data)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.click()
  a.remove()
  const time = setTimeout(() => {
    window.URL.revokeObjectURL(url)
    clearTimeout(time)
  }, 100)
}

export const _genericDownloadFile = (
  { documentName = 'document.pdf', blob = new Blob() } = {
    documentName: 'document.pdf',
    blob: new Blob(),
  }
) => {
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = documentName
  a.click()
  a.remove()
  const time = setTimeout(() => {
    window.URL.revokeObjectURL(url)
    clearTimeout(time)
  }, 100)
}

export class EmailUtils {
  static isValidEmail = (email = '') =>
    new RegExp(/^[\w\-.+]+@([\w-]+\.)+[\w-]{2,4}$/g).test(email)

  static regexEmail = () => new RegExp(/^[\w\-.+]+@([\w-]+\.)+[\w-]{2,4}$/g)
}

/**
 * RETURNS AN OBJECT WITH PERMISSIONS LIKE SO
 * `const = {
      WATCH_STUDENTS: 'WATCH_STUDENTS',
      UNLINK_EXTRAS: 'UNLINK_EXTRAS',
      LINK_EXTRAS: 'LINK_EXTRAS',
    }`
 * @returns {Object<string, string>}
 */
export const _getUserPermissions = (
  { getUser, possibleUserModulePermissions } = {
    getUser,
    possibleUserModulePermissions,
  }
) => {
  if (getUser.id === undefined && getUser.webRole === undefined) {
    return
  }

  const userAccessCatalogs = getUser.webRole.catalogs
  const parsedPossibleUserModulePermissions = Object.values(
    possibleUserModulePermissions
  )

  const tempPermissions = {}
  for (let i = 0; i < userAccessCatalogs.length; i++) {
    const catalog = userAccessCatalogs[i]

    if (parsedPossibleUserModulePermissions.some((e) => e === catalog.name)) {
      tempPermissions[catalog.name] = true
    }
  }
  return tempPermissions
}

export function debounce(func, delay_ms = 300, cb = () => {}) {
  let timer
  return function (...args) {
    clearTimeout(timer)
    cb()
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay_ms)
  }
}
